<template>
  <div id="SectionNetZeroPartner">
    <UIContainer class="SectionNetZeroPartner__container">
      <template #left>
        <img
          class="SectionNetZeroPartner__image"
          src="../assets/netZeroPartner/bg.avif"
          alt="Governance & Controls (Factors, Scope 2, Evidence Vault)"
          loading="lazy"
        />
      </template>

      <template #right>
        <div class="SectionNetZeroPartner__content">
          <SectionTitle titleSize="sm">
            <template #title> Your end-to-end Net Zero partner </template>

            <template #description>
              Partner with certified sustainability experts to create actionable
              net zero plans that deliver measurable results.
            </template>
          </SectionTitle>

          <div class="SectionNetZeroPartner__features">
            <div
              class="SectionNetZeroPartner__feature"
              v-for="feature in features"
              :key="feature"
            >
              <UIIcon
                class="SectionNetZeroPartner__feature-icon"
                name="checkCircle"
              />
              <span>{{ feature }}</span>
            </div>
          </div>

          <div class="SectionNetZeroPartner__cta">
            <UIButton size="xl" theme="primary" :to="{ name: 'Contact' }">
              Book a consultation
            </UIButton>
          </div>
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

const features = [
  'Science-based target setting (SBTi alignment)',
  'Decarbonization pathway modeling',
  'Action plan development and tracking',
  'ROI analysis of net zero investments',
  'Implementation roadmap and milestones',
]
</script>

<style lang="scss" scoped>
#SectionNetZeroPartner {
  position: relative;
  background-color: $color-white;

  .SectionNetZeroPartner__container {
    padding-top: 0;
    // padding-bottom: 0;
  }

  .SectionNetZeroPartner__image {
    display: none;
    width: 100%;

    @include md {
      display: block;
      right: 0;
    }
  }

  .SectionNetZeroPartner__content {
    padding: 1rem 0;
    @include md {
      margin-left: 4rem;
    }
  }

  .SectionNetZeroPartner__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionNetZeroPartner__features {
    display: grid;
    gap: 1.25rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionNetZeroPartner__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionNetZeroPartner__feature-icon {
    --size: 1.75rem;
  }

  .SectionNetZeroPartner__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
